import { Rnd } from 'react-rnd';
import MoveIcon from '../../MyComponents/icons/MoveIcon';
import React from 'react';

const moverActive = {
    cursor: 'move',
    zIndex: 0,
};

const RawDraggerControl = ({
                               point,
                               width = 32,
                               height = 32,
                               el,
                               icon = <MoveIcon />,
                               onStart,
                               onDrag,
                               onStop,
                               cursor,
                           }) => {
    if (cursor) {
        moverActive.cursor = cursor;
    }
    return (
        <Rnd
            key={'stickyControl-' + el.id}
            position={{
                x: point.x,
                y: point.y,
            }}
            size={{
                width,
                height,
            }}
            enableResizing='false'
            bounds='parent'
            dragAxis='both'
            onDragStop={(e, d) => {
                // let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
                // updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                // this.setState({ x: d.x, y: d.y });
                // console.log('=== drag stop', e, d);
                if (onStop) {
                    onStop(e, d);
                }
            }}
            onDragStart={(e, d) => {
                // let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
                // updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                // this.setState({ x: d.x, y: d.y });
                // console.log('=== drag start', e, d);
                if (onStart) {
                    onStart(e, d);
                }
            }}
            onDrag={(e, d) => {
                // let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
                // updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                // this.setState({ x: d.x, y: d.y });
                // console.log('=== drag', e, d);
                if (onDrag) {
                    onDrag(e, d);
                }
            }}
            style={moverActive}
            onTouchStart={(e) => {
                e.stopPropagation();
            }}
            onPointerDown={(e) => {
                e.stopPropagation();
            }}
        >
            {icon}
        </Rnd>
    );
};

export default RawDraggerControl;
